import { useEvents } from './useEvents';

export const SocketWrapper = ({ children }) => {
  useEvents();

  return children;
};
